export default "__VITE_ASSET__388fd86b__"